import {
  JUKE_PATH_A,
  PRODUCT_INVITATION_CARD,
  PRODUCT_JUKE,
  PRODUCT_MICRO_WEBSITE,
  PRODUCT_THEME_TEMPLATE,
  PRODUCT_WECHAT_WEAPP
} from '@constant'
import { isHotelProperty } from '@merchant-backend/util'
import { hasAuthByProductId, isUltimateOrStandard } from '@util'

export default id => {
  const data = [
    {
      id: PRODUCT_THEME_TEMPLATE,
      logo: '//qnm.hunliji.com/o_1c3hgpepo2qtppf1rnpm8fsqu11.png',
      title: '主题模板',
      des: '让你的店铺与众不同',
      href: '#/localMerchant/themeChose',
      serviceDetail:
        '主题模板是婚礼纪为了满足商家店铺装修的需求推出的功能，商家可以选择平台提供的多种主题模板一键使用，配合店铺装修，打造属于自己的店铺风格。',
      coreFn: '提升格调，让你的店铺与众不同',
      appImg: isHotelProperty()
        ? '//qnm.hunliji.com/FumZUhE5eBxYzqE3TNBk-bS2Su70'
        : '//qnm.hunliji.com/o_1c4jit6ks2p23r6m41od91p8un.png',
      name: 'theme_template_buy',
      hasAuth: isUltimateOrStandard()
    },
    {
      id: PRODUCT_MICRO_WEBSITE,
      logo: '//qnm.hunliji.com/o_1d549vgoi1ic6198kr70p0vkhks.png',
      title: '微官网',
      des: '店铺专属移动微官网',
      href: '#/localMerchant/weiShopSetting',
      serviceDetail:
        '微官网是婚礼纪针对用户日益增长的移动浏览需求，为商家打造的简洁移动微官网。商家可以轻松自由设置店铺名称和轮播图，其余模块将自动同步商家在婚礼纪平台上的设置，让每个商家都拥有一个移动微官网。',
      coreFn: '一键配置轻松使用，客资预约轻松管理',
      appImg: isHotelProperty()
        ? '//qnm.hunliji.com/o_1cahh5ik6nevjus1gkl5eu1vijf.png'
        : '//qnm.hunliji.com/o_1c4m6bsilgi6t14jm0ih110gnh.png',
      name: 'wei_shop_buy',
      hasAuth: hasAuthByProductId(PRODUCT_MICRO_WEBSITE)
    },
    {
      id: PRODUCT_WECHAT_WEAPP,
      logo: '//qnm.hunliji.com/o_1d549vgoir0pb0g14411ic81476t.png',
      title: '小程序',
      des: '一键打造微信店铺，增强分享点击转化',
      href: '#/localMerchant/liteApp',
      serviceDetail:
        '微信小程序，基于微信9.63+亿用户，1200万微信公众号，在微信生态形成完美闭环。是最简单、最合适的进入顾客手机微信的方法。把店铺搬到微信里面去，不用下载，点开即用。婚礼纪小程序的推出，帮助商家打通线上线下：线上引流->线下提供婚礼行业解决方案。未来每一家店，都需要一个小程序。',
      coreFn: '微信店铺轻松开 联通线上线下',
      appImg: [
        '//qnm.hunliji.com/o_1d4pjj08e1pe7iui1lrg18j81cc4h.jpg',
        '//qnm.hunliji.com/o_1d4pjj08echfhc01lvn4nc2r3i.jpg',
        '//qnm.hunliji.com/o_1d4pjj08e1usd1dao158ke7qpqaj.jpg',
        '//qnm.hunliji.com/o_1d4pjj08e1gb418dn17n31n0f178vk.jpg',
        '//qnm.hunliji.com/o_1d4pjj08e33etm1dot10nc1b9jl.jpg',
        '//qnm.hunliji.com/o_1d4pjj08eq7m1vom1gpnagtiqim.jpg',
        '//qnm.hunliji.com/o_1d4pjj08e1f9gm9bcl318u2196tn.jpg',
        '//qnm.hunliji.com/o_1d4pjj08evba1u7l1h6q16kp226g.jpg'
      ],
      hasAuth: hasAuthByProductId(PRODUCT_WECHAT_WEAPP)
    },
    {
      id: PRODUCT_JUKE,
      logo: '//qnm.hunliji.com/o_1d549vgoi1s1ccsed4udcr1s7gq.png',
      title: '聚客宝',
      des: '报名平台活动 获取精准客资',
      href: JUKE_PATH_A,
      serviceDetail:
        '聚客宝是婚礼纪推出的商家可自主申请发布活动的营销工具。成功发布的活动会在用户端“热门活动”中展现，有吸引力的活动会为店铺带来更多流量及精准客资。',
      coreFn: '主动发布活动，获取精准客资',
      appImg: '//qnm.hunliji.com/o_1coaemuo33pu1ktt16vff3lle.jpg',
      name: 'juke_buy',
      hasAuth: hasAuthByProductId(PRODUCT_JUKE)
    },
    {
      id: PRODUCT_INVITATION_CARD,
      logo: '//qnm.hunliji.com/o_1d549vgoiq5t3k7be714tu1abvm.png',
      title: '电子请帖',
      des: '数据直观、流量精准、转化高效',
      tips: '该功能仅支持手机端使用',
      href: '',
      serviceDetail: '数据直观、流量精准、转化高效',
      coreFn: '',
      appImg: [
        '//qnm.hunliji.com/o_1d4p0k4ll60mulg1utb3qh2vni.jpg',
        '//qnm.hunliji.com/o_1d4p0k4ll34secc14vogvl1litj.jpg',
        '//qnm.hunliji.com/o_1d4p0k4ll1601172h11907d2ssk.jpg',
        '//qnm.hunliji.com/o_1d4p0k4llibr5ve148p15hk1oall.jpg',
        '//qnm.hunliji.com/o_1d4p0k4ll51618nj9qfq3u1nj8m.jpg',
        '//qnm.hunliji.com/o_1d4p0k4ll13lt1307115f7f61bdfn.jpg',
        '//qnm.hunliji.com/FkNTDPSe0g7ziWBEeMkzaBiYdluQ', // 删除一句文案
        '//qnm.hunliji.com/o_1d4p0k4llaci1eab1obi1k3s3lih.jpg'
      ],
      name: 'dianziqingtie',
      hasAuth: hasAuthByProductId(PRODUCT_INVITATION_CARD)
    }
  ]

  return data.find(item => item.id == id)
}
